<template>
  <div class="view landing">
    <figure class="view-background">
      <img src="@/assets/images/landing@2x.jpg" alt="Photo du Théatre de Liège">
    </figure>

    <div class="view-wrapper">
      <h1 class="h1">Bienvenue sur la nouvelle application du Théâtre de Liège. Ajoutez-la à votre écran d’accueil pour</h1>

      <div class="text">
        <ul>
          <li>Découvrir notre programmation</li>
          <li>Réserver simplement et rapidement vos spectacles</li>
          <li>Centraliser vos billets, votre agenda théâtral et vos coups de cœurs</li>
          <li>Découvrir du contenu additionnel et des offres...</li>
        </ul>
        <p>Cadeau de bienvenue&nbsp;:</p>
        <p v-if="displayTimer">Profitez gratuitement du spectacle Muhammad en direct, sur votre téléphone, dans :</p>
      </div>

      <div
        v-if="displayTimer"
        class="counter"
      >
        <div class="counter-el">
          <span class="counter-el-time">{{ timer.days }}</span>
          <span class="counter-el-label">Jours</span>
        </div>

        <div class="counter-el">
          <span class="counter-el-time">{{ timer.hours }}</span>
          <span class="counter-el-label">Heures</span>
        </div>

        <div class="counter-el">
          <span class="counter-el-time">{{ timer.minutes }}</span>
          <span class="counter-el-label">Minutes</span>
        </div>

        <div class="counter-el">
          <span class="counter-el-time">{{ timer.seconds }}</span>
          <span class="counter-el-label">Secondes</span>
        </div>
      </div>

      <p v-if="displayOver" class="over">Spectacle terminé</p>

      <figure class="picture">
        <img src="@/assets/images/landing-streaming.png" alt="Ismaël Saidi, auteur du spectacle 'Muhammad'">
        <span
          v-if="displayButton"
          class="picture-label"
        >
          Streaming
        </span>
        <a
          v-if="displayButton"
          :href="$store.state.landing.url"
          class="picture-link"
          target="_blank"
        >
          <span class="u-visually-hidden">Accéder au streaming</span>
        </a>
      </figure>

      <btn
        v-if="displayButton"
        :href="$store.state.landing.url"
      >
        Accéder au streaming
      </btn>

      <btn
        :theme="'dark'"
        @click="$router.push({ name: 'Home' })"
      >
        Retour à l'accueil
      </btn>
    </div>
  </div>
</template>

<script>
import Btn from '@/components/components/Btn.vue';

export default {
  components: {
    Btn
  },
  computed: {
    displayTimer() {
      return this.$store.state.landing.display.timer
      && !this.$store.state.landing.display.streaming;
    },
    displayButton() {
      return this.$store.state.landing.display.button || this.$store.state.landing.streaming;
    },
    displayOver() {
      return this.$store.state.landing.display.over;
    },
    timer() {
      return this.$store.state.landing.timer;
    }
  }
};
</script>

<style lang="scss" scoped>
.view {
  @include padding(0 null 50px);

  &-background {
    @include aspect-ratio(375, 415);

    img {
      @include position(absolute, 0 null null 0);
      @include size(100%);
      object-fit: cover;
    }
  }

  &-wrapper {
    @include margin(-126px auto null);
    @include padding(32px 16px);
    position: relative;
    z-index: 1;
    width: calc(100% - 32px);
    background-color: $black-light;

    .h1 {
      font-size: rem(24px);
      line-height: (27/24);
    }

    .text {
      margin-top: 20px;
      font-size: rem(16px);
      line-height: (24 / 16);

      ul {
        li {
          position: relative;
          padding-left: 16px;

          &::before {
            @include position(absolute, 0 null null 0);
            content: '•';
          }

          + li {
            margin-top: 10px;
          }
        }

        + p {
          margin-top: 20px;
        }
      }

      p {
        + p {
          margin-top: 20px;
        }
      }
    }

    .counter {
      display: flex;
      justify-content: center;
      margin-top: 20px;

      &-el {
        display: flex;
        flex-direction: column;
        position: relative;
        width: 58px;

        &:not(:first-child) {
          margin-left: 10px;

          .counter-el-time::before {
            @include position(absolute, 0 100% null null);
            content: ':';
          }
        }

        &-time {
          @include font('secondary', 'regular');
          width: 100%;
          font-size: rem(40px);
          line-height: (47 / 40);
          text-align: center;
        }

        &-label {
          width: 100%;
          font-size: rem(14px);
          line-height: (16/14);
          text-align: center;
        }
      }
    }

    .over {
      @include font('secondary', 'regular');
      margin-top: 20px;
      font-size: rem(32px);
      line-height: 1;
      text-align: center;
    }

    .picture {
      @include aspect-ratio(311, 210);
      margin-top: 20px;
      border-radius: 5px;
      overflow: hidden;

      img {
        @include position(absolute, 0 null null 0);
        @include size(100%);
        object-fit: cover;
      }

      &-label {
        @include position(absolute, 10px null null 10px);
        @include padding(4px 8px);
        color: $primary;
        background-color: $white;
        border-radius: 3px;
        font-size: rem(16px);
        line-height: 1;
      }

      &-link {
        @include position(absolute, 0 null null 0);
        @include size(100%);
        z-index: 1;
      }
    }

    .btn {
      width: 100%;
      margin-top: 20px;

      &.dark {
        background-color: $black;
        border-color: $black;
      }

      + .btn {
        margin-top: 16px;
      }
    }
  }
}
</style>
